import { Autocomplete, Box, Checkbox, Chip, Paper, TextField } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { REQUEST_STATUS, REQUEST_STATUS_NAMES } from '../statusEnums';
import {
  calendarFilterCheckboxSx,
  calendarFilterCountChipSx,
  calendarFilterAutocompleteSx,
  calendarFilterTextFieldSx,
} from './filterStyles';
import { sortSelectedToTop } from './filterUtils';

const FixedWidthPaper = styled(Paper)(() => ({
  width: 220,
}));

const statusOptions = Object.values(REQUEST_STATUS).map((statusId) => ({
  value: statusId,
  label: REQUEST_STATUS_NAMES[statusId],
}));

StatusFilter.propTypes = {
  statusFilter: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      label: PropTypes.string,
    })
  ),
  handleStatusFilterChange: PropTypes.func.isRequired,
};

export function StatusFilter({ statusFilter, handleStatusFilterChange }) {
  const [displayedOptions, setDisplayedOptions] = useState(statusOptions);

  const handleOpen = () => {
    setDisplayedOptions(sortSelectedToTop(statusOptions, statusFilter));
  };
  return (
    <Autocomplete
      multiple
      disableCloseOnSelect
      openOnFocus
      options={displayedOptions}
      onOpen={handleOpen}
      value={statusFilter}
      onChange={handleStatusFilterChange}
      popupIcon={<KeyboardArrowDownIcon sx={{ color: '#707070', fontSize: 16 }} />}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          size="small"
          autoComplete="off"
          sx={calendarFilterTextFieldSx}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <Box
                sx={{ display: 'flex', alignItems: 'center', pointerEvents: 'none' }}
                className="filter-autocomplete-adornment"
              >
                <Box component="span" sx={{ fontSize: '14px', color: '#707070' }}>
                  Status
                </Box>
                {statusFilter.length > 0 ? (
                  <Chip label={statusFilter.length} size="small" sx={{ ...calendarFilterCountChipSx, ml: '8px' }} />
                ) : null}
              </Box>
            ),
          }}
        />
      )}
      renderOption={(props, option, { selected }) => (
        <li {...props} key={option.value}>
          <Checkbox sx={calendarFilterCheckboxSx} checked={selected} />
          {option.label}
        </li>
      )}
      ListboxProps={{ sx: calendarFilterAutocompleteSx }}
      PaperComponent={FixedWidthPaper}
      sx={{ ...calendarFilterAutocompleteSx, ml: 2, minWidth: 136, maxWidth: 136 }}
    />
  );
}
